import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg id="uuid-e3a4e700-0e1f-439a-bf1f-7c0958e73206" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M8 16a8 8 0 00-8-8 8 8 0 008-8 8 8 0 008 8 8 8 0 00-8 8z" fill="#98b7ff" strokeWidth="0" /></svg>);